// Repositorio de datos para las tablas `subscriptions` y `purchases`.
// Cada función encapsula una query Supabase COMPLETA y devuelve el resultado tal cual
// (el objeto `{ data, error }` de supabase-js), para que el call site solo cambie
// `supabase.from("subscriptions")...` por `repoFn(...)` sin tocar su manejo de { data, error }.
//
// Nota: la tabla `purchases` no tiene call sites inline en el frontend (`app/`) al momento
// de crear este repositorio (los usos de "purchases" corresponden a `ai_credit_purchases`,
// otra tabla). Por eso este archivo solo expone wrappers para `subscriptions`; se añadirán
// funciones de `purchases` cuando aparezca el primer call site que las use.
import { supabase } from "../../supabase";

/**
 * Lee la suscripción de un usuario con las columnas de detalle usadas por las utilidades
 * de suscripción Stripe (plan, status, fin de periodo, cancelación programada y customer id).
 * Cubre: app/lib/subscription.ts:14-19 (getSubscription).
 */
export async function getSubscriptionDetail(userId: string) {
  return await supabase
    .from("subscriptions")
    .select("plan_id, status, current_period_end, cancel_at_period_end, stripe_customer_id")
    .eq("user_id", userId)
    .maybeSingle();
}

/**
 * Lee únicamente el plan y el status de la suscripción de un usuario, para la verificación
 * de acceso previa a cargar datos pesados en el flujo de campañas de email.
 * Cubre: app/routes/email-campanas-nueva.tsx:40-44 (clientLoader, subData).
 */
export async function getSubscriptionPlanStatus(userId: string) {
  return await supabase
    .from("subscriptions")
    .select("plan_id, status")
    .eq("user_id", userId)
    .maybeSingle();
}
